<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport="true">
    <div class="sidenav-container">
      <div>
        <div class="user-info-header-container">
          <img
            class="avatar"
            [src]="user?.photo ? user?.photo : '/assets/images/Avatar.svg'"
            alt="avatar"
          />
          <div *ngIf="user" class="user-info">
            <span class="user-name">{{
              user.firstName + " " + user.lastName
            }}</span>
            <small class="line-breaker">
              {{ user.email }}
            </small>
            <span
              *ngIf="hasMultipleTenants"
              mat-raised-button
              class="tenant-name"
              (click)="onChangeTenant()"
            >
              {{ currentTenant }} (alterar)
            </span>
          </div>

          <div class="button-close">
            <img
              src="/assets/icons/menu-close.svg"
              alt="close"
              (click)="drawer.toggle()"
            />
          </div>
        </div>
        <div class="line-separator"></div>
        <mat-nav-list class="features">
          <div *ngFor="let feature of featuresFilter">
            <app-smart-link
              *ngIf="feature.title != 'Sair'"
              activeClass="active"
              customClass="mat-list-item"
              style="padding: 0px 16px;"
              [activeOptions]="{ exact: false }"
              [route]="['/' + feature.route]"
              (onSmartClick)="onFeatureClick($event, feature)"
            >
              <span class="feature-icon">
                <span
                  [matBadge]="feature.unread$ | async"
                  matBadgeColor="accent"
                  class="material-icons-outlined primary-color"
                >
                  {{ feature.icon }}
                </span>
              </span>
              <span class="feature-title">{{ feature.title }}</span>
            </app-smart-link>
            <mat-list-item
              *ngIf="feature.title === 'Sair'"
              (click)="onFeatureClick($event, feature)"
            >
              <span class="feature-icon">
                <span
                  [matBadge]="feature.unread$ | async"
                  matBadgeColor="accent"
                  class="material-icons-outlined primary-color"
                >
                  {{ feature.icon }}
                </span>
              </span>
              <span class="feature-title">{{ feature.title }}</span>
            </mat-list-item>
          </div>
        </mat-nav-list>
        <div class="line-separator"></div>
      </div>
      <div class="logo-container">
        <img
          src="/assets/logos/amais/logo-amais.png"
          srcset="
            /assets/logos/amais/logo-amais@2x.png 2x,
            /assets/logos/amais/logo-amais@3x.png 3x
          "
          class="logo-amais"
        />
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="sidenav-content-container">
      <mat-toolbar color="primary" class="container-1280">
        <div class="container-limit-1280">
          <button
            type="button"
            aria-label="Toggle sidenav"
            mat-icon-button
            (click)="clickMenu()"
          >
            <mat-icon
              aria-label="Side nav toggle icon"
              *ngIf="!disableDrawer && !close"
              >menu</mat-icon
            >
            <mat-icon
              svgIcon="back-arrow"
              *ngIf="disableDrawer && !close"
            ></mat-icon>
            <mat-icon
              class="icon-closed"
              svgIcon="icon-closed"
              *ngIf="close && !disableDrawer"
            ></mat-icon>
          </button>
          <span class="title">{{ title }}</span>

          <app-user-header *ngIf="userHeaderDto" [headerDto]="userHeaderDto">
          </app-user-header>
        </div>
      </mat-toolbar>

      <div class="active-router">
        <ng-content></ng-content>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
